<template>
  <div>

    <!--<CPortada :pseccion="pseccion"></CPortada>-->
    <Cbarra>
        <template slot="slotTitle">Nuestra Historia</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <a href="#">Nosotros</a> / <router-link :to="{name:'historia'}">Nuestra Historia</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal-02">
            <div class="row mb-5">
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <img src="../../assets/style/images/logos/logos_enes020.png" class="img-fluid">
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    <div class="row justify-content-end">
                        <div class="col-11 text-right">
                            <img src="../../assets/style/images/logos/logos_enes021.png" class="img-fluid imagen-historia">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-for="(item,index) in listHistoria" :key="index">
                <div v-if="item.Tipo == 'Banner'" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <img v-for="(loop,key) in item.detalle" :key="key" :src="(loop.Imagen !='')?RutaFile+loop.Imagen:''" class="w-100 img-thumbnail mt-3 mb-3" alt="ENES" v-show="loop.Imagen !=''">
                </div>
                <div v-else class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h5 class="mb-3 color_Azul" v-if="item.Encabezado !=''">{{item.Encabezado}}</h5>
                    <p class="text-justify list-icon" v-if="item.Columnas == 1" v-html="item.Parrafo1"></p>
                    <p class="text-justify list-icon" v-if="(item.Columnas == 2 && item.PosicionImagen == 'IZQ')">
                        <img v-for="(loop,key) in item.detalle" :key="key" :src="(loop.Imagen !='')?RutaFile+loop.Imagen:''" class="img-thumbnail parrafo-img" alt="ENES" v-show="loop.Imagen !=''">
                        <span v-html="item.Parrafo1"></span>
                    </p>
                    <p class="text-justify list-icon" v-if="(item.Columnas == 2 && item.PosicionImagen == 'DER')">
                        <img v-for="(loop,key) in item.detalle" :key="key" :src="(loop.Imagen !='')?RutaFile+loop.Imagen:''" class="img-thumbnail parrafo-img-r" alt="ENES" v-show="loop.Imagen !=''">
                        <span v-html="item.Parrafo1"></span>
                    </p>
                </div>
            </div>

        </div>
    </section>
  </div>
</template>

<script>


export default {
    name:'',
    components:{},
    data() {
        return {
            pseccion:'Historia',
            listHistoria:[],
            RutaFile:'',
        }
    },
    methods: {
        async GetDataHistoria()
        {
            await this.$http.get(
                'inicio/historia/',
                {
                    params:{Seccion:'Historia',TxtBusqueda:'',Entrada:'',pag:'', RegEstatus:'A',Orden:'SI'}
                }
            ).then( (res) => {
                this.listHistoria = res.data.historia;
                this.RutaFile = res.data.RutaFile;
            });
        },
    },
    mounted() {
        this.GetDataHistoria();
    }
}
</script>